import "../styles/LocationAdvantage.css"
import locationbg from "../assets/images/map-bg.webp"
import location from "../assets/images/Location.png"

export default function LocationAdvantage() {
  const locations = [
    { time: "0 Km", place: "130 Mt Road" },
    { time: "4 Km", place: "Delhi World Public School" },
    { time: "5.6 Km", place: "Yatharth Super Speciality Hospital" },
    { time: "7.7 Km", place: "Gaur Chowk" },
    { time: "11 Km", place: "Parthala Chowk" },
    { time: "12 Km", place: "NH" },
    { time: "16 Km", place: "Pari Chowk" },
  ]

  return (
    <section id="location" className="location-advantage">
      <div className="location-container">
        <div className="location-left">
          <h3 className="section-label1">LOCATION ADVANTAGE</h3>
          {/* <div className="section-label-underline"></div> */}
          <h2 className="section-title">Prime Location Boosts Connectivity</h2>

          <div className="timeline">
            {locations.map((location, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-line"></div>
                <div className="timeline-content">
                  <div className="timeline-time">
                    <strong>{location.time}</strong>
                  </div>
                  <div className="timeline-place">{location.place}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* 
        <div className="location-right">
          <a
            href="https://maps.google.com/maps?q=28.56687355041504%2C77.48138427734375&z=17&hl=en"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/images/Location.png"
              alt="Location Map"
              className="map-image"
            />
          </a>
        </div> */}

        <div className="location-right">
          <div className="map-container">
            <img
              src={`${location}`}
              alt="Location Map"
              className="map-image"
            />
            <a
              href="https://maps.google.com/maps?q=28.56687355041504%2C77.48138427734375&z=17&hl=en"
              target="_blank"
              rel="noopener noreferrer"
              className="map-view-btn"
            >
              View on Map
            </a>
          </div>
        </div>

        <style>{`
        .location-advantage {
  position: relative;
  padding: 80px 20px;
  background-color: var(--light-color);
  max-width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
}

.location-advantage::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${locationbg});
  background-size: cover;
  background-position: center;
  opacity: 0.05; 
  z-index: -1;
}
      `}</style>

      </div>
    </section>
  )
}